import axiosInstance from '@/services/axiosInstance';
import { pickBody } from '@/api/helpers';

export type CalendarTask = {
  id: string;
  organizationId: string;
  calendarId: string | null;
  eventId: string | null;
  title: string;
  notes: string | null;
  dueAt: string | null;
  completedAt: string | null;
  status: string;
  priority: string;
  reminderOffsetsMinutes?: number[] | null;
  createdById: string;
  updatedById: string | null;
  createdAt: string;
  updatedAt: string;
};

type ListResponse = { success?: boolean; data: CalendarTask[] };

export type ListTasksParams = {
  calendarId?: string;
  status?: string;
  dueBefore?: string;
  dueAfter?: string;
};

const list = (params?: ListTasksParams): Promise<CalendarTask[]> =>
  axiosInstance.get<unknown>('/api/v1/tasks', { params }).then((res) => {
    const raw = pickBody<ListResponse | CalendarTask[]>(res.data);
    if (Array.isArray(raw)) return raw;
    return raw?.data ?? [];
  });

export type CreateTaskInput = {
  title: string;
  notes?: string | null;
  calendarId?: string | null;
  eventId?: string | null;
  dueAt?: string | null;
  status?: 'NEEDS_ACTION' | 'COMPLETED' | 'CANCELLED';
  priority?: 'NONE' | 'LOW' | 'MEDIUM' | 'HIGH';
  reminderOffsetsMinutes?: number[];
};

const create = (input: CreateTaskInput): Promise<CalendarTask> =>
  axiosInstance.post<unknown>('/api/v1/tasks', input).then((res) => {
    const raw = pickBody<{ success?: boolean; data: CalendarTask }>(res.data);
    return raw.data;
  });

const tasksApi = {
  list,
  create,
};

export { tasksApi };
